module.exports = __webpack_public_path__ + "static/dragon_red_attack-78234eaddf096f1f0f8e0fc749f43fe9.jpg";